var React = require('react');

function UserGrid1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.15","fillRule":"evenodd","clipRule":"evenodd","d":"M489.591 556.562C536.99 518.857 468.588 431.859 461.199 365.858C454.257 303.851 485.404 242.581 448.266 187.429C405.292 123.611 332.444 71.6215 261.152 68.781C191.334 65.9992 141.887 119.34 106.855 173.826C77.9702 218.75 72.7305 277.853 89.7598 335.347C103.848 382.911 147.332 415.906 187.979 447.716C221.138 473.666 257.938 483.153 296.328 497.007C362.698 520.959 441.045 595.179 489.591 556.562Z","fill":"#709BE7"}));
}

UserGrid1.defaultProps = {"width":"658","height":"658","viewBox":"0 0 658 658","fill":"none"};

module.exports = UserGrid1;

UserGrid1.default = UserGrid1;
